import { UserAgentPublicApp } from "@maersk-global/iam-al";

export const config = {
  /**
   * @description: the uri that's whitelisted in AM for OAuth2
   */
  // redirect_uri: 'https://fleetvoyage.dev.maersk-digital.net',
  redirect_uri: (<any>window)["appenv"].loginInfo?.redirectUri,

  /**
   * @description: Your application client id
   */
  client_id: 'fleet001',
  // client_id: 'bca001',

  //bca001
  /**
    * @description: The url of the authority, e.g https://accounts.maersk.com/developer
    */
  authority: (<any>window)["appenv"].loginInfo?.authority,
  storage: {
    /**
     * @default: "localStorage"
     * @description: the type of storage you want to utilize to store the tokens
     * choices are sessionStoragesession lived tokens, and localStorage, for permanent storing (until deleted)
     */
    type: "localStorage"
  },
  /**
   * default: "iamAL"
   * this will give the AL instance name in the global scope (window.iamAL)
   */
 // window_namespace: "maerskAL",

  post_logout_uri: 'http://localhost:4000',

}

export const al = new UserAgentPublicApp(config); 

export const getTokenInfo = () => {
  return localStorage.getItem((<any>window)["appenv"].loginInfo?.idToken);
}
